export const GOAL_EDUCATION = "EDUCATION";
export const GOAL_RETIREMENT = "RETIREMENT";
export const GOAL_LIFESTYLE = "LIFESTYLE";
export const GOAL_LEGACY = "LEGACY";
export const GOAL_TAX_PLANNING = "TAX_PLANNING";

export const GOAL_BASED = "GOALS_BASED";
export const SSR_PLAN = "SAFE_SAVINGS_RATE";

export const MONTH_LIST = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const MONTH_MAP = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const MONTH_LABEL_MAP = {
  1: "Jan",
  2: "Feb",
  3: "Mar",
  4: "Apr",
  5: "May",
  6: "Jun",
  7: "Jul",
  8: "Aug",
  9: "Sep",
  10: "Oct",
  11: "Nov",
  12: "Dec",
};

export const MONTH_NUM_MAP = {
  Jan: 1,
  Feb: 2,
  Mar: 3,
  Apr: 4,
  May: 5,
  Jun: 6,
  Jul: 7,
  Aug: 8,
  Sep: 9,
  Oct: 10,
  Nov: 11,
  Dec: 12,
};

export const MONTH_FULL_NUM_MAP = {
  Jan: "01",
  Feb: "02",
  Mar: "03",
  Apr: "04",
  May: "05",
  Jun: "06",
  Jul: "07",
  Aug: "08",
  Sep: "09",
  Oct: "10",
  Nov: "11",
  Dec: "12",
};

export const MONTH_FULL_NAME_MAP = {
  1: "January",
  2: "February",
  3: "March",
  4: "April",
  5: "May",
  6: "June",
  7: "July",
  8: "August",
  9: "September",
  10: "October",
  11: "November",
  12: "December",
};

export const MONTH_NAME_MAP = {
  1: "Jan",
  2: "Feb",
  3: "Mar",
  4: "Apr",
  5: "May",
  6: "Jun",
  7: "Jul",
  8: "Aug",
  9: "Sep",
  10: "Oct",
  11: "Nov",
  12: "Dec",
};

export const MORTGAGE_TYPE_MAP = {
  3: { key: "FIXED", name: "Fixed" },
  4: { key: "ARM", name: "ARM" },
  5: { key: "INTERESTONLY", name: "Interest Only" },
  6: { key: "BALLOON", name: "Balloon" },
};

export const STANDARD_DEBOUNCE_DELAY = 1000;

export const TAX_CATEGORY_DEFERRED = "TAX_DEFERRED";
export const TAX_CATEGORY_TAXABLE = "TAXABLE";
export const TAX_CATEGORY_EXEMPT = "TAX_EXEMPT";

export const ACCOUNTTYPE_401k = "TAX_DEFERRED_401K";
export const ACCOUNTTYPE_403B = "TAX_DEFERRED_403B";
export const ACCOUNTTYPE_BENEFICIARY = "BENEFICIARY_IRA";
export const ACCOUNTTYPE_INDIVIDUAL_401K = "INDIVIDUAL_401K";
export const ACCOUNTTYPE_DEFINED_CONTRIBUTION = "DEFINED_CONTRIBUTION_PLAN";
export const ACCOUNTTYPE_DEFINED_BENEFIT = "DEFINED_BENEFIT_PLAN";
export const ACCOUNTTYPE_FIXED_ANNUITY = "FIXED_ANNUITY";
export const ACCOUNTTYPE_PROFIT_SHARING_PLAN = "PROFIT_SHARING_PLAN";
export const ACCOUNTTYPE_ROLLOVER_IRA = "ROLLOVER_IRA";
export const ACCOUNTTYPE_SEP_IRA = "SEP_IRA";
export const ACCOUNTTYPE_SIMPLE_IRA = "SIMPLE_IRA";
export const ACCOUNTTYPE_TRADITIONAL_IRA = "TRADITIONAL_IRA";
export const ACCOUNTTYPE_VARIABLE_ANNUITY = "VARIABLE_ANNUITY";
export const ACCOUNTTYPE_ESOP = "ESOP";
export const ACCOUNTTYPE_OTHER = "TAXABLE_OTHER";

export const ACCOUNTTYPE_BROKERAGE = "BROKERAGE";
export const ACCOUNTTYPE_INDIVIDUAL = "INDIVIDUAL";
export const ACCOUNTTYPE_TRUST = "TRUST";
export const ACCOUNTTYPE_JOINT_ACCOUNT = "JOINT";
export const ACCOUNTTYPE_TENANTS_BY_ENTIRETY = "TENANTS_BY_ENTIRETY";
export const ACCOUNTYPE_TENANTS_IN_COMMON = "TENANTS_IN_COMMON";
export const ACCOUNTTYPE_CUSTODIAL_ACCOUNT = "CUSTODIAL";
export const ACCOUNTTYPE_CORPORATE_ACCOUNT = "CORPORATE";
export const ACCOUNTTYPE_PARTNERSHIP = "PARTNERSHIP";
export const ACCOUNTTYPE_SOLE_PROPRIETORSHIP = "SOLE_PROPRIETORSHIP";

export const ACCOUNTTYPE_ROTH_IRA = "ROTH_IRA";
export const ACCOUNTTYPE_ROTH_401K = "ROTH_401K";
export const ACCOUNTTYPE_529_PLAN = "TAX_EXEMPT_529_PLAN";
export const ACCOUNTTYPE_COVERDELL_ESA = "COVERDELL_ESA";
export const ACCOUNTTYPE_CASH_ACCOUNT = "CASH";

export const CUSTODIAN_TDAMERITRADE = "TD_AMERITRADE";
export const CUSTODIAN_CHARLESSCHWABB = "CHARLES_SCHWAB";
export const CUSTODIAN_PERSHING = "PERSHING";
export const CUSTODIAN_FIDELITY = "FIDELITY";
export const CUSTODIAN_OTHER = "OTHER";

export const MANAGED_MANAGED = "MANAGED";
export const MANAGED_MANAGED_FULL_CUSTODY = "FULL_CUSTODY";
export const MANAGED_NOT_MANAGED = "NOT_MANAGED";

export const DATATYPE_CLIENT = "CLIENT";
export const DATATYPE_COCLIENT = "COCLIENT";
export const DATATYPE_FAMILY = "FAMILY";
export const DATATYPE_OTHER = "OTHER";

export const MALE = "Male";
export const FEMALE = "Female";
export const NON_BINARY = "Non Binary";
export const GENDER_OTHER = "Other";
export const PREFER_NOT_TO_SAY = "Prefer Not to Say";
export const CLIENT = "CLIENT";
export const COCLIENT = "COCLIENT";
export const BENEFICIARY = "BENEFICIARY";
export const SPOUSE = "SPOUSE_PARTNER";
export const SON = "SON";
export const DAUGHTER = "DAUGHTER";
export const FATHER = "FATHER";
export const MOTHER = "MOTHER";
export const SISTER = "SISTER";
export const BROTHER = "BROTHER";
export const GRANDPARENT = "GRANDPARENT";
export const EXTENDED_FAMILY = "EXTENDED_FAMILY";
export const GRANDSON = "GRANDSON";
export const GRANDDAUGHTER = "GRANDDAUGHTER";
export const FIANCE = "FIANCEE";
export const OTHER = "OTHER";
export const CPA = "CPA";
export const POA = "POA";

export const GENDER_MAP = {
  "MALE": MALE,
  "FEMALE": FEMALE,
  "NON_BINARY": NON_BINARY,
  "OTHER": GENDER_OTHER,
  "PREFER_NOT_TO_SAY": PREFER_NOT_TO_SAY,
};

export const GENDER_VALUE_MAP = {
  "Male": "MALE",
  "Female": "FEMALE",
  "Non Binary": "NON_BINARY",
  "Other": "OTHER",
  "Prefer Not to Say": "PREFER_NOT_TO_SAY",
};

export const MARRY_STATUS_MAP = {
  true: "Yes",
  false: "No",
};

export const DEFAULT_PAGE_SIZE = 10;

export const STATE_TAX = "STATE_TAX";
export const CAPITAL_GAINS_TAX = "CAPITAL_GAINS_TAX";
export const INCOME_TAX = "INCOME_TAX";

export const EARLIEST_YEAR = 1900;
export const LATEST_YEAR = 2150;
export const YOUNGEST_AGE = 0;
export const OLDEST_AGE = 200;

export const EXPENSE_ROW = "EXPENSE_ROW";
export const GOAL_ROW = "GOAL_ROW";

export const REGULAR_DATE = "REGULAR_DATE";
export const RETIREMENT_DATE = "RETIREMENT_DATE";
export const MORTALITY_DATE = "MORTALITY_DATE";

export const MORTGAGE_TYPES = [
  {
    key: "FIXED",
    name: "Fixed",
  },
  {
    key: "ARM",
    name: "Arm",
  },
  {
    key: "INTERESTONLY",
    name: "Interest Only",
  },
  {
    key: "BALLOON",
    name: "Balloon",
  },
];

export const PaymentIntervals = [
  {
    key: "ANNUAL",
    name: "Annually",
  },
  {
    key: "QUARTERLY",
    name: "Quarterly",
  },
  {
    key: "MONTHLY",
    name: "Monthly",
  },
  {
    key: "WEEKLY",
    name: "Weekly",
  },
];

export const RMD_ACCOUNT_TYPES = [
  ACCOUNTTYPE_401k,
  ACCOUNTTYPE_403B,
  ACCOUNTTYPE_BENEFICIARY,
  ACCOUNTTYPE_DEFINED_BENEFIT,
  ACCOUNTTYPE_DEFINED_CONTRIBUTION,
  ACCOUNTTYPE_FIXED_ANNUITY,
  ACCOUNTTYPE_INDIVIDUAL_401K,
  ACCOUNTTYPE_PROFIT_SHARING_PLAN,
  ACCOUNTTYPE_ROLLOVER_IRA,
  ACCOUNTTYPE_SEP_IRA,
  ACCOUNTTYPE_SIMPLE_IRA,
  ACCOUNTTYPE_TRADITIONAL_IRA,
  ACCOUNTTYPE_VARIABLE_ANNUITY,
  ACCOUNTTYPE_ESOP,
];